import React from "react";

// 游戏分类基础信息
export interface GameCategoryInfo {
  // 分类唯一标识符
  key: string;
  // 分类名称键，用于国际化
  nameKey: string;
  // 分类显示名称（后备）
  name: string;
  // 图标组件
  icon: React.ReactNode;
  // 路由路径
  path: string;
  // 数据键路径，用于从API响应中获取数据
  dataKey?: string;
  // 是否需要认证
  auth?: boolean;
  // 是否在移动端显示
  showOnMobile?: boolean;
  // 移动端显示限制数量
  mobileLimit?: number;
  // 是否忽略
  ignore?: boolean;
  // 分类类型
  type?: GameCategoryType;
  // 排序权重
  sort?: number;
  // 是否启用
  enabled?: boolean;
}

// 游戏分类类型枚举
export enum GameCategoryType {
  // 首页
  HOME = "home",
  // 热门
  HOT = "hot",
  // 推荐
  RECOMMEND = "recommend",
  // 老虎机
  SLOT = "slot",
  // 棋牌
  TABLE = "table",
  // 捕鱼
  FISHING = "fishing",
  // 体育
  SPORT = "sport",
  // 视讯
  LIVE = "live",
  // 小游戏
  MINI = "mini",
  // 原创
  ORIGINAL = "original",
  // 平台类游戏
  PLATFORM = "platform",
  // 收藏
  FAVORITE = "favorite",
  // 最近玩过
  PLAYED = "played",
}
